import {Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OfferPeriodDeleteConfiguration} from "@core/shared/models/offer/offer-period/offer-period-delete";
import {OfferOptionPeriodDeleteComponent} from "@core/components/offer/offer-option/offer-option-period/offer-option-period-delete/offer-option-period-delete.component";
import {OfferOption} from "@core/shared/models/offer/offer-option";

@Component({
    selector: 'app-core-offer-option-period-delete-dialog',
    templateUrl: './offer-option-period-delete-dialog.component.html',
    styleUrls: ['./offer-option-period-delete-dialog.component.scss'],
    standalone: false
})
export class OfferOptionPeriodDeleteDialogComponent implements OnInit {

    @Output() delete: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild(OfferOptionPeriodDeleteComponent) offerOptionPeriodDeleteComponent: OfferOptionPeriodDeleteComponent;

    constructor(
        private _dialogRef: MatDialogRef<OfferOptionPeriodDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { option: OfferOption }
    ) {
    }

    ngOnInit(): void {

        const events: EventEmitter<any>[] = [
            this.delete
        ];

        events.forEach((event: EventEmitter<void>): void => {

            event.subscribe((): void => {

                this._dialogRef.close();
            })
        });
    }

    public close(): void {

        this._dialogRef.close();
    }

    public submit(): void {

        this.offerOptionPeriodDeleteComponent.formService.submit();
    }

    get option(): OfferOption {

        return this.data.option;
    }

    get configuration(): OfferPeriodDeleteConfiguration {

        return {
            showSubmitButton: false
        };
    }
}
